import { styled, css } from 'styled-components';
import { BREAKPOINTS } from '../../constants/layout.mjs';
import { SkeletonLoaderDarkMixin, SkeletonLoaderMixin } from '../../constants/mixin.mjs';
import { theme } from '../../constants/theme.mjs';
import '../StyleableSvgImage/index.mjs';
import { StyleableSvgImage } from '../StyleableSvgImage/StyleableSvgImage.mjs';
"use strict";
const FullscreenButton = styled.button`
  position: absolute;
  bottom: 30px;
  right: 30px;
  margin: 0;
  border: none;
  background: rgb(255 255 255 / 0.6);
  cursor: pointer;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  color: ${theme.colors.primaryBlue};
  opacity: 0;
  border-radius: 6px;
  transition: opacity 0.2s ease-in-out;

  @media ${BREAKPOINTS.TABLET_AND_DOWN} {
    bottom: 15px;
    right: 15px;
  }

  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    opacity: 1;

    bottom: 10px;
    right: 10px;
  }
`;
const ZoomIcon = styled(StyleableSvgImage)`
  @media ${BREAKPOINTS.MOBILE_AND_DOWN} {
    height: 18px;
    width: 18px;
  }
`;
const ImageWrapOuter = styled.div`
  display: flex;
  align-items: center;
  aspect-ratio: 1;
  height: 100%;
  margin: 0 auto;
  align-self: center;
  position: relative;

  ${({
  $responsive
}) => $responsive && css`
      aspect-ratio: auto;
      width: 100%;
    `}

  &:hover {
    ${FullscreenButton} {
      opacity: 1;
    }
  }
`;
const ImageSkeletonLoader = styled.div`
  top: 0;

  ${({
  $motif
}) => $motif === "dark" ? SkeletonLoaderDarkMixin : SkeletonLoaderMixin}

  ${({
  $responsive
}) => $responsive && css`
      aspect-ratio: auto;
      height: 100%;
    `}

  ${({
  $disableBorderRadius
}) => $disableBorderRadius && css`
      border-radius: 0;
    `}
`;
const ImageWrap = styled.div`
  ${({
  $objectFit
}) => ($objectFit === "contain" || $objectFit === "cover") && css`
      height: 100%;
    `}

  ${({
  $clickable
}) => $clickable && css`
      cursor: pointer;
    `}


  margin: auto;
  position: relative;

  /**
   * HACK: Needed to make next/image with layout "fill" visible in Safari
   */
  ${({
  layout
}) => layout === "fill" && css`
      && > span {
        height: 100% !important;
      }
    `}

  > img {
    width: 100%;
    height: 100%;
    display: block;

    ${({
  $objectFit
}) => $objectFit && css`
        object-fit: ${$objectFit};
      `}
  }

  ${({
  $sizes,
  margin
}) => css`
    width: calc(${$sizes} - ${margin ?? 0}px);
  `}
`;
const FallbackImageWrap = styled.div`
  margin: 0 auto;
  position: relative;

  /* TODO is this needed? */
  aspect-ratio: 1;

  ${({
  $margin,
  $fallbackImageSize
}) => {
  switch ($fallbackImageSize) {
    case "large":
      return css`
          width: ${`calc(80% - ${$margin ?? 0}px)`};
        `;
    case "small":
      return css`
          width: ${`calc(40% - ${$margin ?? 0}px)`};
        `;
    case "tiny":
      return css`
          width: ${`calc(30% - ${$margin ?? 0}px)`};
        `;
    case "medium":
    default:
      return css`
          width: ${`calc(60% - ${$margin ?? 0}px)`};
        `;
  }
}}

  /* HACK: Needed to make it a block to center an intrinsic next/image, there is probably a cleaner solution  */
  > * {
    display: block !important;
    width: 100%;
  }
`;
const FullscreenImageWrap = styled.div`
  position: fixed;
  inset: 0;
  z-index: ${theme.zIndex.modal};
  background-color: #fff;

  > img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: contain;
  }
`;
const FullscreenCloseButton = styled.button`
  position: absolute;
  top: 30px;
  left: 30px;
  margin: 0;
  border: none;
  background: none;
  cursor: pointer;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  background-color: ${theme.colors.black10};
  height: 36px;
  width: 36px;
  border-radius: 50%;
  color: ${theme.colors.black65};
`;
export { FallbackImageWrap, FullscreenButton, FullscreenCloseButton, FullscreenImageWrap, ImageSkeletonLoader, ImageWrap, ImageWrapOuter, ZoomIcon };
//# sourceMappingURL=CustomImage.styles.mjs.map
